
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import ShareBtn from '@/components/ShareBtn.vue'

@Options({
    components: { ShareBtn },
    mounted () {
        this.$common.pageLoaded()
        this.$common.track('load', '进入规则页')
    }
})
export default class Rule extends Vue {}
